import { Component, Input, OnChanges, ElementRef, Renderer2 } from '@angular/core';
import { MktModalService } from 'src/app/core/services/mkt-modal.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { FootnoteService } from 'src/app/common/services/footnote.service';
import { MktTaggingTransformationService } from 'src/app/core/services';
const ADDITIONAL_INFO_URL = 'additional-information';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'ui-card-links',
  templateUrl: './card-links.component.html',
  styleUrls: ['./card-links.component.scss'],
  standalone: false
})
export class CardLinksComponent implements OnChanges {

  isModalOpen :boolean = false;

  @Input('additionalLinks') additionalLinks: any;
  @Input('cardName') cardName: string;
  @Input() additionalInfoData: any;
  @Input() card: any={};
  @Input() pid: string;
  @Input() hashcode: string;
  @Input() page;

  additionalInfoContent: any;

  constructor(
    private modalService: MktModalService,
    private _mktTagging:MktTaggingTransformationService,
    private router: Router,
    private location: Location,
    private footnoteService: FootnoteService,
    private elementRef: ElementRef,
    private renderer2: Renderer2) {}

  ngOnChanges({card}: any){
    if(card.currentValue !== card.previousValue){
      let instance = setTimeout(()=>{
        clearTimeout(instance);
        this.footnoteService.addFootNote(this.elementRef, this.renderer2, card.currentValue, this.navigateToAdditionalInfoPage, this, 'cc')
      },0);
    }
  }

  comparePricingTagging(event: MouseEvent){
    let taggingDynamicProp = {
      category: 'cards:acquisition',
      product_name: "c:" + this.pid,
      acquisition_source_code: this.hashcode
    }

    this._mktTagging.tagMktCompareCards('comparePricingLink', {
      products: [taggingDynamicProp],
      pid: this.pid,
      link_name:'Important Pricing & Information',
    });
  }

  navigateToAdditionalInfoPage(event: MouseEvent){
    this.additionalInfoData = {
      content: '',
      siteCatalyst: {},
      showCancelButton: true,
      cancelButtonText: 'Close',
      primaryButtonText: '',
      url: '',
      useDefaults: false,
      ...this.additionalInfoData
    };
    this.additionalInfoData.genericTemplateContent = this.additionalInfoData;
    this.openAdditionalInfoPage(event);
  }

  openAdditionalInfoPage(event={}){
    let taggingDynamicProp = {
      category: 'cards:acquisition',
      product_name: "c:" + this.pid,
      acquisition_source_code: this.hashcode
    }

    this._mktTagging.tagMktCompareCards('compareAdditionalInfo', {
      products: [taggingDynamicProp],
      pid: this.pid,
    });
     //this._mktTagging.tagMktCompareCards('cardAdditionalInfo', {});
     // Open modal
     if (!this.isModalOpen) {
       this.isModalOpen=true;
      const modalInstance = this.modalService.openModal(event, this.additionalInfoData, false);

      // Setup Subscriptions
      if (true) {
        const handleOnClose = () => {

          this.closeAdditionalInfoPage();

          modalCloseSub.unsubscribe();
          modalContinueSub.unsubscribe();
        };

        // Subscribe to modal close emitter
        const modalCloseSub = !!modalInstance && modalInstance.onClose.subscribe(handleOnClose.bind(this));

        // Subscribe to modal continue emitter
        const modalContinueSub = !!modalInstance && modalInstance.onContinue.subscribe(handleOnClose.bind(this));
      }
    }

     return false;
  }

  private closeAdditionalInfoPage() {
    console.log('onclose -model');
    this.isModalOpen=false;
    const arr = this.router.url.split('?');
    arr[0] = arr[0].split('/').filter(part => part != ADDITIONAL_INFO_URL).join('/');
    this.location.replaceState(arr.join('?'));
  // this.router.navigate([ ...currentPageURL ], { replaceUrl: true });
  }

  // getAriaLabel(link) {
  //   return `${this.cardName} ${link.key}`;
  // }

  getAnchorText(link, i) {
    return `<span><sup aria-hidden="true" style="color:#0c71b0;">${i + 1}</sup> ${link.key}</span>`;
  }

}
